import React, { FC, useState } from 'react';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import styles from './UnConditionalTransfer.module.scss';
import { useIsWhiteLabel } from '@/components/app/providers/whiteLabelProvider/WhiteLabelProvider';
import { ProductItemTypes } from '@/components/houses/_types/productItem.types';
const Content = ['در صورت نقض قوانین توسط میزبان یا مهمان، امکان استفاده از جابجایی بی‌قید و شرط وجود ندارد.', 'در طول رزرو تنها ۱ مرتبه می‌توان از امکان جابجایی استفاده کرد.', 'پس از تایید درخواست جابجایی، تمام مبلغ رزرو، به صورت اعتبار غیر قابل  برداشت به کیف پول شما در «شب» واریز می‌شود و این مبلغ تا ساعت ۱۲ شب همان روز، قابل استفاده است.', 'جابجایی بی‌قید و شرط تا ۱ ساعت پس از تحویل اقامتگاه امکان‌پذیر است.'];
const WhiteLabelContent = ['در صورت نقض قوانین توسط میزبان یا مهمان، امکان استفاده از جابجایی بی‌قید و شرط وجود ندارد.', 'در طول رزرو تنها ۱ مرتبه می‌توان از امکان جابجایی استفاده کرد.', 'پس از تایید درخواست جابجایی، تمام مبلغ رزرو، به صورت اعتبار غیر قابل  برداشت به کیف پول شما در سایت واریز می‌شود و این مبلغ تا ساعت ۱۲ شب همان روز، قابل استفاده است.', 'جابجایی بی‌قید و شرط تا ۱ ساعت پس از تحویل اقامتگاه امکان‌پذیر است.'];
interface UnConditionalTransferProps {
  productState?: ProductItemTypes;
}
const UnConditionalTransfer: FC<UnConditionalTransferProps> = ({
  productState
}) => {
  const [showMore, setShowMore] = useState(false);
  const isWhiteLabel = useIsWhiteLabel();
  const unconditionalContent = isWhiteLabel ? WhiteLabelContent : Content;
  const isUnitCount = productState?.is_units_count;
  return <Box className={styles['unConditional-transfer'] + ' ' + `${showMore ? styles['open'] : ''}`} data-sentry-element="Box" data-sentry-component="UnConditionalTransfer" data-sentry-source-file="UnConditionalTransfer.tsx">
      <Box className={styles['header-rules-item']} data-sentry-element="Box" data-sentry-source-file="UnConditionalTransfer.tsx">
        <Icon name="shield-tick-Filled" type="white" className={styles['icon']} data-sentry-element="Icon" data-sentry-source-file="UnConditionalTransfer.tsx" />
        <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="UnConditionalTransfer.tsx">
          {isUnitCount ? 'امکان جابجایی بی قید و شرط برای این اقامتگاه فعال نیست.' : 'جابجایی بی قید و شرط!'}
        </Typography>
      </Box>
      {!isUnitCount && <>
          <Box className={styles['description-rules-item']}>
            <Typography variant="bodyS" className={styles['description-rules-text']}>
              با <b> &quot;خیال راحت&quot; </b> رزرو کن. به هر دلیلی راضی نباشی٬
              بی قید و شرط و<b> &quot;رایگان&quot; </b> جا به جات میکنیم.
            </Typography>

            <Box component="ul" className={styles['unconditional-transfer-content']}>
              {unconditionalContent.map((item, index) => <Typography component="li" variant="bodyS" key={'UNCONDITIONAL_TRANSFER_CONTENT_' + index}>
                  {item}
                </Typography>)}
            </Box>
          </Box>
          <Box onClick={() => setShowMore(!showMore)} className={styles['show-more-box']}>
            <Typography variant="bodyS">
              {showMore ? 'بستن' : 'مشاهده جزییات'}
            </Typography>
            <Icon name={showMore ? 'arrow-up-1' : 'arrow-down-1'} type="white" />
          </Box>
        </>}
    </Box>;
};
export default UnConditionalTransfer;